export const useWindowDimensions = (flag, setFlag, limit) => {

    const updateWindowDimensions = () => {
        let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        let height = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        return {
            width,
            height
        };
    }

    const handleResize = () => {
        const { width } = updateWindowDimensions();
        if (width <= limit) {
            if (!flag) {
                setFlag(true);
            }
        } else {
            setFlag(false);
        }
    }

    return [handleResize];
}